import { render, staticRenderFns } from "./saleTixianShen.vue?vue&type=template&id=140598d6&"
import script from "./saleTixianShen.vue?vue&type=script&lang=js&"
export * from "./saleTixianShen.vue?vue&type=script&lang=js&"
import style0 from "./saleTixianShen.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports